export default "__VITE_ASSET__ceecd6ba__"